import React from "react";
import Footer from "../components/Home/Footer";
import "../components/Home/Home.css";

/**
 * Om Oss — dedicated page with detailed information about Al-Yasin.
 */
function OmOss() {
  return (
    <div className="d-flex flex-column min-vh-100">
      {/* ─── Hero Banner ─── */}
      <section
        className="py-5 text-center text-white"
        style={{
          background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
        }}
      >
        <div className="container py-4">
          <h1 className="display-4 fw-bold mb-3" style={{ color: "#d4af37" }}>
            🌙 Om Al-Yasin
          </h1>
          <p className="lead mb-0" style={{ maxWidth: "700px", margin: "0 auto" }}>
            Koranundervisning, kulturelle aktiviteter og forebyggende arbeid for
            barn og unge i lokalsamfunnet.
          </p>
        </div>
      </section>

      {/* ─── Hvem er vi ─── */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <h2 className="fw-bold mb-3" style={{ color: "#0f3460" }}>
                Hvem er vi?
              </h2>
              <p className="text-muted">
                <strong>Al-Yasin</strong> er en frivillig organisasjon stiftet med formål om å
                tilby koranundervisning og kulturelle aktiviteter for barn og unge.
                Vi jobber aktivt for å styrke unge menneskers tilknytning til
                Koranens verdier om fred, ansvar og fellesskap.
              </p>
              <p className="text-muted">
                Organisasjonen ble grunnlagt av engasjerte medlemmer i
                lokalsamfunnet som så behovet for et trygt og inkluderende
                miljø der barn og unge kan lære, vokse og utvikle seg.
              </p>
              <p className="text-muted mb-0">
                <strong>Organisasjonsnummer:</strong> 936 686 958
              </p>
            </div>
            <div className="col-lg-6 text-center">
              <div
                className="rounded-4 p-4 d-flex align-items-center justify-content-center w-100"
                style={{
                  background: "linear-gradient(135deg, #f8f9fa, #e9ecef)",
                  minHeight: "300px",
                }}
              >
                <img
                  src="/images/logo.jpeg"
                  alt="Al-Yasin logo"
                  className="img-fluid rounded-4"
                  style={{ maxHeight: "280px", width: "100%", objectFit: "contain" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── Vårt formål ─── */}
      <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container">
          <h2 className="text-center fw-bold mb-2" style={{ color: "#0f3460" }}>
            Vårt formål
          </h2>
          <p className="text-center text-muted mb-5">
            Al-Yasin arbeider for å oppnå følgende mål
          </p>

          <div className="row g-4">
            {[
              {
                icon: "📖",
                title: "Koranundervisning",
                text: "Tilby strukturert koranundervisning med fokus på tajweed, hifz og tafsir for alle aldersgrupper og nivåer.",
              },
              {
                icon: "🛡️",
                title: "Forebyggende arbeid",
                text: "Drive forebyggende arbeid mot rus, kriminalitet og ekstremisme gjennom Koranens verdier om fred, ansvar og lovlydighet.",
              },
              {
                icon: "🎓",
                title: "Kurs & seminarer",
                text: "Arrangere kurs, seminarer og workshops som fremmer kunnskap, personlig utvikling og kulturell forståelse.",
              },
              {
                icon: "👨‍👩‍👧‍👦",
                title: "Familieaktiviteter",
                text: "Skape et inkluderende rom for familier med fellesarrangementer, quiz-kvelder, og sosiale sammenkomster.",
              },
              {
                icon: "🤝",
                title: "Samfunnsengasjement",
                text: "Bidra positivt til lokalsamfunnet gjennom frivillig arbeid, dialogmøter og tverrkulturellt samarbeid.",
              },
              {
                icon: "🌟",
                title: "Ungdomsutvikling",
                text: "Styrke ungdommers selvtillit, identitet og tilhørighet gjennom mentorordninger og lederutvikling.",
              },
            ].map((item, i) => (
              <div key={i} className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm rounded-4">
                  <div className="card-body text-center p-4">
                    <div style={{ fontSize: "2.5rem" }} className="mb-3">
                      {item.icon}
                    </div>
                    <h5 className="fw-bold">{item.title}</h5>
                    <p className="text-muted mb-0">{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── Våre verdier ─── */}
      <section className="py-5 bg-white">
        <div className="container">
          <h2 className="text-center fw-bold mb-2" style={{ color: "#0f3460" }}>
            Våre verdier
          </h2>
          <p className="text-center text-muted mb-5">
            Grunnverdiene som veileder alt vi gjør
          </p>

          <div className="row g-4 justify-content-center">
            {[
              { emoji: "☪️", value: "Tro", desc: "Koranens lære som fundament for alt arbeid" },
              { emoji: "📚", value: "Kunnskap", desc: "Livslang læring og personlig utvikling" },
              { emoji: "🕊️", value: "Fred", desc: "Fremme av fred, dialog og forståelse" },
              { emoji: "💛", value: "Inkludering", desc: "Åpent og trygt for alle uavhengig av bakgrunn" },
              { emoji: "🤲", value: "Fellesskap", desc: "Styrke båndene i lokalsamfunnet" },
            ].map((v, i) => (
              <div key={i} className="col-6 col-md-4 col-lg">
                <div className="text-center p-3">
                  <div style={{ fontSize: "2.5rem" }} className="mb-2">
                    {v.emoji}
                  </div>
                  <h6 className="fw-bold" style={{ color: "#d4af37" }}>
                    {v.value}
                  </h6>
                  <small className="text-muted">{v.desc}</small>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── Kontakt oss ─── */}
      <section
        className="py-5 text-white"
        style={{
          background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
        }}
      >
        <div className="container text-center">
          <h2 className="fw-bold mb-3" style={{ color: "#d4af37" }}>
            📬 Kontakt oss
          </h2>
          <p className="mb-4" style={{ maxWidth: "600px", margin: "0 auto" }}>
            Har du spørsmål eller ønsker å bli med i Al-Yasin? Ta gjerne kontakt
            med oss.
          </p>
          <div className="row justify-content-center g-4">
            <div className="col-md-4">
              <div className="p-3 rounded-4" style={{ background: "rgba(255,255,255,0.08)" }}>
                <div style={{ fontSize: "2rem" }}>📧</div>
                <h6 className="mt-2 fw-bold">E-post</h6>
                <a
                  href="mailto:admin@alyasin.no"
                  className="text-decoration-none"
                  style={{ color: "#d4af37" }}
                >
                  admin@alyasin.no
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-3 rounded-4" style={{ background: "rgba(255,255,255,0.08)" }}>
                <div style={{ fontSize: "2rem" }}>📍</div>
                <h6 className="mt-2 fw-bold">Sted</h6>
                <span style={{ color: "#b0b0b0" }}>Al-Yasin-senteret</span>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-3 rounded-4" style={{ background: "rgba(255,255,255,0.08)" }}>
                <div style={{ fontSize: "2rem" }}>🌐</div>
                <h6 className="mt-2 fw-bold">Sosiale medier</h6>
                <div className="d-flex justify-content-center gap-3">
                  <a href="https://facebook.com" target="_blank" rel="noreferrer" style={{ color: "#d4af37" }}>Facebook</a>
                  <a href="https://instagram.com" target="_blank" rel="noreferrer" style={{ color: "#d4af37" }}>Instagram</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default OmOss;
